import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppColors } from '../context/PreferencesContext';
import type { TrackingDetails } from '../types/locationTracking';
import { buildTrackingMapHtml } from '../utils/trackingMapHtml';
import { trackingMapColors } from './TrackingMapLegend';

type Props = { details: TrackingDetails; height: number };

/** Route and markers in a sandboxed iframe (web). */
export function TrackingMap({ details, height }: Props) {
  const palette = useAppColors();
  const html = useMemo(
    () => buildTrackingMapHtml(details, trackingMapColors(palette), palette.surface),
    [details, palette],
  );
  return (
    <View
      style={[styles.frame, { height, borderColor: palette.border }]}
      accessibilityLabel="Tracking map"
    >
      {React.createElement('iframe', {
        'data-testid': 'tracking-map',
        title: 'Tracking map',
        srcDoc: html,
        // Scripts only; no same-origin access to the app.
        sandbox: 'allow-scripts allow-popups allow-popups-to-escape-sandbox',
        style: { border: 0, width: '100%', height: '100%', display: 'block' },
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  frame: { width: '100%', borderWidth: 1, borderRadius: 12, overflow: 'hidden' },
});
